import * as NavigationUtils from "./navigation";
import * as EmailSearch from "./emailSearch";
import * as FAQ from "./faq";
import * as PwnedPasswords from "./passwords";
import * as LoadingButton from "./loadingButton";
import * as PwnedWebsites from "./pwned_websites";
import * as OptOut from "./optout";
import * as EmailVerification from "./email_verification";
import * as EmailChange from "./change_email_confirmation";
import * as Pricing from "./pricing";
import * as DashboardInternal from "./dashboard_internal";
import * as Dashboard from "./dashboard";
import * as NotifyMe from "./notify_me";
import { initTurnstile } from "./turnstile";
/**
 * Custom JavaScript for Have I Been Pwned
 * Contains functionality for domain search page and other interactive elements
 */
// @ts-ignore
const appInsights = window.appInsights;
// Domain Search Page Functionality
document.addEventListener("DOMContentLoaded", async () => {
    // Initialize the turnstile widget
    initTurnstile();
    // Initialize loading buttons
    LoadingButton.initializeLoadingButtonsOnPageLoad();
    // Initialize domain search page if elements exist
    if (document.getElementById("domainsTableView") || document.getElementById("noDomainView")) {
        //DomainSearch.initDomainSearchPage();
    }
    // Initialize breach timeline functionality if elements exist
    EmailSearch.initEmailSearch();
    // Initialize navbar menu background toggle
    NavigationUtils.initNavbarMenuToggle();
    // Initialize FAQ accordion functionality and deep links
    FAQ.initializeFAQSearch();
    FAQ.initializeFAQDeepLinks();
    // Initialize Pwned Passwords search
    PwnedPasswords.initializePwnedPasswordsSearch();
    // Initialize Pwned Websites table
    PwnedWebsites.initializeBreachTable();
    // Initialize Opt-out page
    OptOut.initializeOptOutPage();
    // Initialize Email Verification page
    EmailVerification.initializeEmailVerification();
    // Initialize Email Change page
    EmailChange.initializeEmailChange();
    // Initialize Pricing page
    Pricing.initializePricingPage();
    // Initialize Dashboard page
    Dashboard.initializeDashboardPage();
    // Initialize Dashboard Internal page
    await DashboardInternal.initializeDashboardInternal();
    // Initialize Notify Me page
    NotifyMe.initializeNotifyMePage();
});
/**
 * Get the Bootstrap color class based on severity
 * @param {string} severity - The severity level (low, medium, high)
 * @returns {string} - The Bootstrap color class
 */
function getSeverityClass(severity) {
    switch (severity.toLowerCase()) {
        case "high":
            return "danger";
        case "medium":
            return "warning";
        case "low":
            return "secondary";
        default:
            return "secondary";
    }
}
